// core dependencies
import Log from 'loglevel';
import Vue from 'vue';
import VueResource from 'vue-resource';
import Vuex from 'vuex';

// bootstrap lib
import jQuery from 'jquery';
import Tether from 'tether';
import Bootstrap from 'bootstrap';
// import bootstrap from 'bootstrap-sass'
// import '../node_modules/bootstrap/dist/css/bootstrap.css';

// local source
import Router from './routes.js';
import {
  mapLang
} from './routes.js';
import App from './App.vue';
import ClientStore from './store/index.js';

Vue.use(Bootstrap);
Vue.use(Vuex);



/*
import button-x from 'components/button.vue';
Vue.component('button-x', {})
*/
// paths that would not need auth
const PwPaths = ['/api/v1/KH/auth', '/api/v1/KH/register-account', '/api/v1/payment/charge', '/api/v1/KH/getback-account'];

// create global Auth variable
const AuthPlugin = {
  setToken: function (token, expiration) {
    localStorage.setItem('authToken', token);
    localStorage.setItem('authTokenExpiration', expiration);
  },

  destroyToken: function () {
    //Log.info('remove token');
    localStorage.clear();
    //localStorage.removeItem('authToken');
    //localStorage.removeItem('authTokenExpiration');
    //localStorage.removeItem('user.name');
    //localStorage.removeItem('user');
    //localStorage.removeItem('res');
    //localStorage.removeItem('rftime');
  },

  getToken: function () {
    let token = localStorage.getItem('authToken');
    let expiration = localStorage.getItem('authTokenExpiration');

    if (!token || !expiration) return null;

    if (Date.now() > parseInt(expiration)) {
      // this.destroyToken();
      return null;
    } else {
      return token;
    }
  },

  getLang: function () {
    const lang = mapLang();
    //Log.info('language: ', lang);
    return lang;
  },

  loggedIn: function () {
    //Log.info('check if logged: token: ', this.getToken());
    if (this.getToken()) return true;
    else return false;
  }
};

function Auth(Vue) {
  Vue.auth = AuthPlugin;
  Object.defineProperties(Vue.prototype, {
    $auth: {
      get: () => {
        return Vue.auth;
      }
    }
  });
}

Vue.use(VueResource);
Vue.use(new Auth(Vue));
Log.setLevel('info');
//Log.info('process env: ', process.env);

// intercept every http request with added token
Vue.http.interceptors.push((request, next) => {
  //Log.info('push interceptors: ', request.method);
  let token = Vue.auth.getToken();
  // hack: inject access token
  if (token) {
    if (request.method === 'POST') {
      request.body.token = {
        access_token: token
      };
    }
    if (request.method !== 'options') {    // == GET or POST
      request.headers.set('Authorization', 'Bearer ' + token);
    }
  }  // if token
  next();
 /* 
  if (request.method === 'POST') {
    if (token) {
      request.body.token = {
        access_token: token
      };
    }
  }
  //Log.info('intercept: ', token, request);
  if (token) {
    if (request.method !== 'options') {    // == GET  ==POST
      request.headers.set('Authorization', 'Bearer ' + token);
    }
    next();
  } else {
    //Log.info('no token found: ', token, request);
    if (request.url.match(PwPaths[0]) || request.url.match(PwPaths[1])
        || request.url.match(PwPaths[2]) || request.url.match(PwPaths[3])) {
      // allow no token for PwPaths
      next();
    } else {
      Log.error('auth: no token');
      setTimeout(() => {
        Log.info('timeout token');
        Router.go('auth');
      }, 123000);
    }
  }
*/
});

// configure auth to start by using VueRouter.beforeEach
Router.beforeEach(function (to, from, next) {
  //Log.info('guard check!!', to);

  // if (to.matched.some(record => record.meta.requiresAuth)) {

  //     //prevent access to 'requiresGuest' routes;
  //     if (Vue.auth.loggedIn()) {
  //         next({
  //             path: '/home/en'
  //         });
  //     } else {
  //         Log.info('not logged in: ok: ', to, from, next);
  //         next({
  //             path: '/auth/login',
  //             query: { redirect: to.fullPath }
  //         }); // make sure to always call next()!
  //     }
  
  if (to.matched.some((record) => record.meta.requiresAuth) && Vue.auth.loggedIn()) {
    Log.info('auth required, logged in');
    next();
  } else if (to.matched.some((record) => record.meta.requiresAuth) && !Vue.auth.loggedIn()) {
    Log.info('auth required, not logged in');
    //Log.info('auth required, not logged in', to, from, next);
    next({
      path: '/auth/' + Vue.auth.getLang() + '/login',
      // path: 'entry',
      query: {
        redirect: to.fullPath
      },
      parameters: {
        language: Vue.auth.getLang()
      }
    });
  } else {
    //Log.info('auth not required: ', to);
    Log.info('auth not required: ');
    next();
  }
});

// hack: share variables

// vue instance
new Vue({
  el: '#app',
  data: {},
  router: Router,
  render: (h) => h(App),
  // use vuex state, mutations, actions
  store: ClientStore
});


// WEBPACK FOOTER //
// ./src/main.js